import { render } from "./NewsTab.vue?vue&type=template&id=462eeb83"
import script from "./NewsTab.vue?vue&type=script&lang=js"
export * from "./NewsTab.vue?vue&type=script&lang=js"

import "./NewsTab.vue?vue&type=style&index=0&id=462eeb83&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__